import { getter } from '../../proxyGetter'

import { appBanner } from './appBanner'
import { promotionLabel } from './promotionLabel'
import { pricingPage } from './pricingPage'

export const holiday = new Proxy(
  {
    appBanner,
    pricingPage,
    promotionLabel,
    default: {},
  },
  { get: getter },
)
